module.exports = __webpack_public_path__ + "static/media/01.334f3f17.jpg";